import Breadcrumb from './Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';
Breadcrumb.Item = BreadcrumbItem;
export default Breadcrumb;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/breadcrumb/index.js
// module id = 593
// module chunks = 0